import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function QuantityCheckMarkIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 18 18"
        {...props}
      >
        <path d="M9 1c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8" />
        <path
          fill="#FFF"
          d="M7.76 13.18c-.27 0-.53-.11-.72-.3L4.09 9.85c-.38-.4-.38-1.03.02-1.42a.987.987 0 0 1 1.41.02l2.27 2.33 5-4.74a.996.996 0 0 1 1.41.03c.38.4.36 1.03-.04 1.41L8.45 12.9c-.18.18-.43.28-.69.28"
        />
      </svg>
    </Icon>
  )
}
export default QuantityCheckMarkIcon
